export const defaultSizes = {
    cardWidth: '290px',
    cardHeight: '220px',
};
